/**
 *    Mam - Download counter
 */

(function ($) {
  Drupal.behaviors.downloadCounter = {
    attach() {
      $('.vb-button-add-bookmarks').on('click', () => {
        const $target = $('[data-fav-count-type]');
        if (!$target.hasClass('animation-scale')) {
          $target.addClass('animation-scale');
          setTimeout(() => {
            $target.removeClass('animation-scale');
          }, 600);
        }
      });
    },
  };
}(jQuery));

// end of mam--download-counter.js
